<script>

import NewArticle from "@/views/components/cms/new/NewArticle.vue";

export default {
  name: "RentenClearUpErklaerVideoNew",
  components: {
    NewArticle,
  },
}
</script>

<template>
  <NewArticle :category-id="8"></NewArticle>
</template>

<style scoped>

</style>
